'use strict';
import Helper from '../utils/Helper';
const ThemeColorBuilder = function (themeColor, accentColor, id) {
    const lightAccentHex = accentColor !== undefined ? Helper.lightenColorHex(accentColor, 70) : '';
    const accentRgb = accentColor !== undefined ? Helper.colorToRgb(accentColor) : undefined;
    const extraLightAccentHex = accentRgb !== undefined && accentRgb !== null ? `rgba(${accentRgb.r},${accentRgb.g},${accentRgb.b},10%)` : '';
    const darkAccentHex = accentColor !== undefined ? Helper.darkenColorHex(accentColor, 16) : '';
    const batchBuild = (idName) => {
        const idString = idName !== undefined ? `${idName} ` : '';
        return `body,${idString}.ss360-layer, body .unibox, .ss360-comparison-bar {
			--ss360-theme-color: ${themeColor};
			--ss360-accent-color: ${accentColor};
			--ss360-accent-color-dark: ${darkAccentHex};
			--ss360-accent-color-light: ${lightAccentHex};
			--ss360-accent-color-light-transparent: ${extraLightAccentHex};
		}`;
    };
    return {
        build() {
            return `${batchBuild()}${batchBuild(id)}`;
        }
    };
};
export default ThemeColorBuilder;
